import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { isLogin } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

function TopBanner({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  return (
    <Container onClick={() => navigate('/promotion/땅집고옥션-럭키-이벤트')}>
      <img
        src="/assets/images/banner/payment-topbanner-lucky.png"
        alt="banner"
      />
      {/* <Inner>
        <Title>
          <img src="/assets/images/ai-search/magnifier.svg" alt="" />
          <span>AI 경공매 찾기</span> 체험하기
        </Title>
        <img src="/assets/images/ai-search/beta.svg" alt="beta" />
      </Inner> */}
    </Container>
  );
}

export default TopBanner;

const Container = styled.div`
  width: 100%;
  max-height: 54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #3048f3;

  cursor: pointer;

  & > img {
    height: 100%;
    width: 100%;
  }
`;

const Inner = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: center;
  padding: 6px 0;

  font-weight: 500;
  font-size: 18px;
  color: white;

  span {
    font-weight: 700;
  }
`;
